import { z } from 'zod';

export const ScanRequestMeterSchema = z.enum(['credit', 'starter_audit']);

export type ScanRequestMeter = z.infer<typeof ScanRequestMeterSchema>;
